export enum LoginSharedActions {
  SUCESS,
  FAIL
}
